import React from 'react'
import moment from 'moment'
import { useBillingSelector } from 'store/billingSlice/billingReducer'
import {
  ClockCircleTwoTone,
  CreditCardTwoTone,
  StopTwoTone,
} from '@ant-design/icons'
import NotificationBanner from './NotificationBanner'

const NotificationBar = () => {
  const { subscription } = useBillingSelector()

  const getTrialDaysLeftDescription = () => {
    if (Number(subscription?.TrialDaysLeft) > 0) {
      if (subscription?.TrialDaysLeft === 1) {
        return 'Your trial ends in 1 day.'
      }
      return `Your trial ends in ${subscription?.TrialDaysLeft} days.`
    }
    if (subscription?.TrialDaysLeft === 0) {
      return 'Your trial ends today.'
    }
    return 'Your trial has ended.'
  }

  const isTrailDaysLeftAreUnderWeek =
    subscription?.SubscriptionStatus === 'Active' &&
    subscription?.IsPaymentMethodPresent === false &&
    Number(subscription?.TrialDaysLeft) <= 7
  return (
    <>
      {/* Show when user is on trail */}
      {subscription?.SubscriptionStatus === 'Active' &&
        subscription?.IsTrialEnded === false && (
          <NotificationBanner
            icon={
              <ClockCircleTwoTone
                style={{ fontSize: '2rem' }}
                twoToneColor="#1BA1E2"
              />
            }
            heading={getTrialDaysLeftDescription()}
            description={`Subscription will be will automatically renew on ${moment(
              subscription?.NextPaymentDate,
            ).format('dddd, DD MMMM YYYY')}.`}
          />
        )}

      {/* Show when user subscription's expired */}
      {subscription?.SubscriptionStatus === 'Expired' && (
        <NotificationBanner
          icon={
            <StopTwoTone style={{ fontSize: '2rem' }} twoToneColor="#E0373A" />
          }
          heading="Subscription Expired"
          description={`Your subscription ended on on ${moment(
            subscription?.NextPaymentDate,
          ).format('dddd, DD MMMM YYYY')}.`}
        />
      )}

      {/* Show when user is on trail */}
      {subscription?.SubscriptionStatus === 'Active' &&
        isTrailDaysLeftAreUnderWeek && (
          <NotificationBanner
            icon={
              <CreditCardTwoTone
                style={{ fontSize: '2rem' }}
                twoToneColor="#E0373A"
              />
            }
            heading="Payment method required"
            description={`Please add your payment method before ${moment(
              subscription?.NextPaymentDate,
            ).format('dddd, DD MMMM YYYY')} to avoid any service interruption.`}
          />
        )}
    </>
  )
}

export default NotificationBar
